/**
 *
 * @module MediaPlayer events enum
 * @desc MediaPlayer event enumeration
 *
 */
export default {
    MEDIA_PLAYER_CREATED: 'MEDIA_PLAYER_CREATED',
    MEDIA_REPLAY: 'MEDIA_REPLAY',
    PLAYER_RESIZED: 'PLAYER_RESIZED',
};
